export enum SalaryType {
    Daily = 'DAILY',
    Hourly = 'HOURLY',
    Weekly = 'WEEKLY',
    Monthly = 'MONTHLY',
    Yearly = 'YEARLY',
}
